import React, { useState } from 'react'
import { Container } from 'components/Layout'
import { MobileServiceForm } from '../MobileServiceForm'
import HeadingBanner from 'components/Text/HeadingBanner'
import cn from 'classnames'
import sText from 'components/Text/Text.scss'

export const MobileServiceFormModal = props => {
  const [headings, setHeadings] = useState({
    heading: '',
    subHeading: '',
  })

  return (
    <div>
      <HeadingBanner filled>
        <h3 className={cn(sText.heading3, sText.accent)}>{headings.heading}</h3>
        <div className={sText.descrip2}>{headings.subHeading}</div>
      </HeadingBanner>

      <Container paddingTop paddingBottom className="sm">
        <MobileServiceForm onCancel={props.modalCancel} setHeadings={setHeadings} />
      </Container>
    </div>
  )
}



// WEBPACK FOOTER //
// src/features/MobileServices/MobileServiceFormModal/MobileServiceFormModal.tsx